











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.User.PromoteUserToAdminCommand')
    
    export class PromoteUserToAdminCommand {
        constructor( userId: number ) {
            
                this.userId = userId;
            
        }

        
            public userId: number;
        
    }

    export interface IPromoteUserToAdminCommand {
        
            userId: number;
        
    }

    export async function promoteUserToAdmin( command: PromoteUserToAdminCommand ): Promise<CommandResult<void>>
    export async function promoteUserToAdmin( { userId }: IPromoteUserToAdminCommand ): Promise<CommandResult<void>>
    export async function promoteUserToAdmin( model: any ): Promise<CommandResult<void>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<void>;

        if(model instanceof PromoteUserToAdminCommand) {
            result = await endpoint.send<CommandResult<void>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<void>>( new PromoteUserToAdminCommand( model['userId'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace PromoteUserToAdminCommand.ExtraneousTypes {
        

        
    }

